import styleText from './as-trinckle-label.css?raw';

export class AsTrinckleLabel extends HTMLElement {
  private static readonly sheet = (() => {
    const sheet = new CSSStyleSheet();
    sheet.replaceSync(styleText);
    return sheet;
  })();

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.shadowRoot!.adoptedStyleSheets = [
      ...this.shadowRoot!.adoptedStyleSheets,
      AsTrinckleLabel.sheet
    ];

    this.shadowRoot!.innerHTML = /*html*/`
      <as-text dict-key="footer.trinckle-label">
        trinckle design automation application | Powered by paramate
      </as-text>
    `;
  }
}

if (!customElements.get('as-trinckle-label')) {
  customElements.define('as-trinckle-label', AsTrinckleLabel);
}
